module.exports.rqb = (tableName, name, columns, sql, args, sqlChange) => {
  window.jQuery("#rqb").empty();
  // eslint-disable-next-line no-undef
  RedQueryBuilderFactory.create(
    {
      meta: {
        tables: [
          {
            name: tableName,
            label: name,
            columns: columns,
            fks: []
          }
        ],
        types: [
          {
            editor: "SUGGEST",
            operators: [
              {
                name: "=",
                label: "is",
                cardinality: "ONE"
              },
              {
                name: "<>",
                label: "is not",
                cardinality: "ONE"
              },
              {
                name: "LIKE",
                label: "like",
                cardinality: "ONE"
              },
              {
                name: "<",
                label: "less than",
                cardinality: "ONE"
              },
              {
                name: ">",
                label: "greater than",
                cardinality: "ONE"
              }
            ],
            name: "CHAR"
          },
          {
            editor: "NUMBER",
            operators: [
              {
                name: "=",
                label: "is",
                cardinality: "ONE"
              },
              {
                name: "<>",
                label: "is not",
                cardinality: "ONE"
              },
              {
                name: "<",
                label: "less than",
                cardinality: "ONE"
              },
              {
                name: ">",
                label: "greater than",
                cardinality: "ONE"
              }
            ],
            name: "NUMERIC"
          },
          {
            editor: "NUMBER",
            operators: [
              {
                name: "=",
                label: "is",
                cardinality: "ONE"
              },
              {
                name: "<>",
                label: "is not",
                cardinality: "ONE"
              },
              {
                name: "<",
                label: "less than",
                cardinality: "ONE"
              },
              {
                name: ">",
                label: "greater than",
                cardinality: "ONE"
              }
            ],
            name: "INTEGER"
          },
          {
            editor: "NUMBER",
            operators: [
              {
                name: "=",
                label: "is",
                cardinality: "ONE"
              },
              {
                name: "<>",
                label: "is not",
                cardinality: "ONE"
              },
              {
                name: "<",
                label: "less than",
                cardinality: "ONE"
              },
              {
                name: ">",
                label: "greater than",
                cardinality: "ONE"
              }
            ],
            name: "DECIMAL"
          },
          {
            editor: "NUMBER",
            operators: [
              {
                name: "=",
                label: "is",
                cardinality: "ONE"
              },
              {
                name: "<>",
                label: "is not",
                cardinality: "ONE"
              },
              {
                name: "<",
                label: "less than",
                cardinality: "ONE"
              },
              {
                name: ">",
                label: "greater than",
                cardinality: "ONE"
              }
            ],
            name: "SMALLINT"
          },
          {
            editor: "SELECT",
            operators: [
              {
                name: "=",
                label: "is",
                cardinality: "ONE"
              }
            ],
            name: "BOOLEAN"
          },
          {
            name: "STRING",
            editor: "TEXT",
            operators: [
              {
                name: "=",
                label: "is",
                cardinality: "ONE"
              },
              {
                name: "!=",
                label: "not is",
                cardinality: "ONE"
              },
              {
                name: "like",
                label: "like",
                cardinality: "ONE"
              }
            ]
          },
          {
            name: "DATE",
            editor: "DATE",
            operators: [
              {
                name: "=",
                label: "is",
                cardinality: "ONE"
              },
              {
                name: "<",
                label: "less than",
                cardinality: "ONE"
              },
              {
                name: ">",
                label: "greater than",
                cardinality: "ONE"
              }
            ]
          }
        ]
      },
      onSqlChange: sqlChange
    },
    sql,
    args
  );
};
